var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._g(_vm._b({attrs:{"value":_vm.value,"outlined":"","rules":_vm.rules,"background-color":_vm.color,"persistent-placeholder":"","type":"number"}},'v-text-field',_vm.$attrs,false),_vm.inputListeners))}
var staticRenderFns = []

export { render, staticRenderFns }